<template>
  <div class="footer">
    <div class="content">
      <div class="left">
        <div class="button-box">
          <a target="_blank" href="https://www.nicednb.com/cp/company02.do">회사소개</a>
          <a target="_blank" href="https://www.nicednb.com/cs/cs-center03-pp.do">개인정보처리방침</a>
          <a target="_blank" href="https://www.nicednb.com/cs/cs-center03-ci.do">신용정보활용체제공시</a>
          <a target="_blank" href="https://www.nicednb.com/cs/cs-center03-ec.do">이메일무단수집거부</a>
        </div>
        <div class="txt-box">
          <p>(04535) 서울특별시 중구 소공로 70 포스트타워 B동, 16층 ㈜나이스디앤비</p>
          <p>
            통신판매업신고 : 제2012-서울마포-0168호
            <span class="bar"></span> 사업자등록번호 : 107-86-24874
          </p>
          <p>
            TEL : 02-2122-0277
            <span class="bar"></span> FAX : 02-2122-2528
          </p>
        </div>
        <p class="copyright">ⓒ COPYRIGHT 2006 NICE D&B Co.,Ltd. ALL RIGHTS RESERVED.</p>
      </div>
      <div class="right">
        <a href>
          <img src="@/assets/images/logo.png" alt />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>